'use strict';

function LoanApplicationIncomeSemiMonthly() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._$classes = {
    form: '.js--loan-application-semi-monthly-form',
    nextBtn: '.js--next',
    prevBtn: '.js--previous',
    firstPaySelector: '.js--first-pay',
    secondPaySelector: '.js--second-pay',
    firstPayHeader: '.js--first-pay-header',
    secondPayHeader: '.js--second-pay-header',
    secondPayDateDropDown: '.js--month-select'
  };

  this._fieldsInteractedWith = [];
  this._submissionFlag = false;

  this._firstPayDay = null;
  this._secondPayDay = null;
  this._currentStep = 1;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._$node = $(this.node);
    this._$form = this._$node.find(this._$classes.form);
    this._$nextBtn = this._$node.find(this._$classes.nextBtn);
    this._$prevBtn = this._$node.find(this._$classes.prevBtn);
    this._$firstPaySelector = this._$node.find(this._$classes.firstPaySelector);
    this._$secondPaySelector = this._$node.find(this._$classes.secondPaySelector);
    this._$firstPayHeader = this._$node.find(this._$classes.firstPayHeader);
    this._$secondPayHeader = this._$node.find(this._$classes.secondPayHeader);
    this._$secondPayDateDropDown = this._$node.find(this._$classes.secondPayDateDropDown);

    this._pushPageAnalytics('first');
    this._setupEventHandlers();
    this._setupComputedVariables();
    this._setupForm();
    this._removeProgressLoader();
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._setupForm = function () {
    this._setPayDateAttr('first'); // set first step next btn data analytics id

    $('.js--default-footer').removeClass('hide');
    if (this._currentStep === 1) {
      this._$firstPaySelector.removeClass('hide');
      this._$firstPayHeader.removeClass('hide');
    } else if (this._currentStep === 2) {
      this._$secondPaySelector.removeClass('hide');
      this._$secondPayHeader.removeClass('hide');
    }
    // Populate Dropdown
    for (var i = 1; i < 16; i++) {
      var isLast = i === 15;
      this._$firstPaySelector.find('select').mogo().addOption(i, i, false, isLast);
    }
  };

  this._setupComputedVariables = function () {
    var _this = this;

    // first date dropdown
    this.presenter.addComputedVariable('first_payday_of_month', ['money._loanApplicationIncome.first_pay_date'], function (dateString) {
      var firstPayDate = void 0;
      if (dateString) {
        firstPayDate = moment(dateString).format('D');
        return firstPayDate;
      }
    });

    // Radio group
    this.presenter.addComputedVariable('last_day', ['money._loanApplicationIncome.last_day_of_month'], function (val) {
      if (_this.presenter.getModelProperty('money._loanApplicationIncome.second_pay_date')) {
        return false;
      }

      return val;
    });
  };

  this._setupEventHandlers = function () {
    var _this2 = this;

    this._$form.on('submit', function (e) {
      e.preventDefault();

      _this2._firstPayDay = _this2._$firstPaySelector.find('select').val();
      _this2._secondPayDay = _this2._$secondPaySelector.find('select').val();

      if (!_this2._firstPayDay) {
        _this2._$firstPaySelector.find('select').mogo().showErrorLabel();
        _this2._pushFormErrorAnalytics('first_payday');
        return;
      }

      if (_this2._firstPayDay && _this2._currentStep === 1) {
        // push submission event before going to the next page.
        _this2._pushPayDateFormSubmitAnalytics('first');

        _this2._$firstPaySelector.addClass('hide');
        _this2._$firstPayHeader.addClass('hide');
        _this2._$secondPaySelector.removeClass('hide');
        _this2._$secondPayHeader.removeClass('hide');
        _this2._createSecondDropDown();

        // Set up next day analytics
        _this2._resetInteractedFields();
        _this2._pushPageAnalytics('second');
        _this2._setPayDateAttr('second'); // set second pay date next btn attr

        if (_this2.presenter.getModelProperty('money._loanApplicationEdit') === true) {
          $('.js--editable-footer').removeClass('hide');
          $('.js--default-footer').addClass('hide');
        }
        _this2._currentStep = 2;
      } else if (_this2._currentStep === 2) {
        var data = _this2._$form.serializeFormToObj();
        var lastDayOfMonthBoolean = data.last_day_of_month;
        var dayOfMonthVal = data.day_of_month;
        // Check for empty values
        if (!lastDayOfMonthBoolean) {
          _this2._$secondPaySelector.mogo().showErrorLabel();
          _this2._pushFormErrorAnalytics('second_payday');
          return;
        }
        if (lastDayOfMonthBoolean === 'false' && !dayOfMonthVal) {
          _this2._$secondPayDateDropDown.mogo().showErrorLabel();
          _this2._pushFormErrorAnalytics('day_of_month');
          return;
        }
        _this2._$nextBtn.mogo().setDisabledLoadState();
        _this2._loanApplications[0].saveSemiMonthlyPayFrequency(lastDayOfMonthBoolean, _this2._firstPayDay, _this2._secondPayDay);
        _this2._loanApplications[0].submitIncome({
          success: _this2._onSubmitIncomeSuccess.bind(_this2),
          failure: _this2._onSubmitIncomeFailure.bind(_this2)
        });
      }
    });

    this._$prevBtn.on('click', function (e) {
      e.preventDefault();
      // Sending Member Navigation manually because the page is faked in to two steps
      _this2.analytics.forcePushEvent('generic-member-navigation', {
        memberNavigation: ['Money-Navigation-Previous-Navigation-Component']
      });

      if (_this2._currentStep === 2) {
        // push submission event before going to the next page.
        _this2._pushAbandonmentData();
        _this2._resetInteractedFields();

        _this2._$secondPaySelector.addClass('hide');
        _this2._$secondPayHeader.addClass('hide');
        _this2._$firstPaySelector.removeClass('hide');
        _this2._$firstPayHeader.removeClass('hide');

        // Set first pay date analytics
        _this2._pushPageAnalytics('first');
        _this2._setPayDateAttr('first');
        _this2._setSubmissionFlag(false);

        // TODO: This is temporary solution for removing the options from current dropdown since they will be re-generated based on the first pay day. Need to add removeOptions method in the dropdown component.
        _this2._$secondPaySelector.find('select :not([disabled="disabled"])').remove();
        _this2._$secondPaySelector.find('ul li:not(.disabled)').remove();
        // when you go back to step 1, you can edit
        if (_this2.presenter.getModelProperty('money._loanApplicationEdit') === true) {
          $('.js--editable-footer').addClass('hide');
          $('.js--default-footer').removeClass('hide');
        }
        _this2._currentStep = 1;
      } else if (_this2._currentStep === 1) {
        _this2._history.goToUrl(_this2.paths.loans.application_flow_income);
      }
    });

    this._$firstPaySelector.find('select').on('change', function () {
      _this2._$firstPaySelector.find('select').mogo().hideError();
      _this2._$firstPaySelector.find('select').mogo().hideErrorLabel();
    });

    this._$form.on('change', this._onOptionSelected.bind(this));

    // Form Abandonment
    this._onFieldInteraction(this._$firstPaySelector.find('select'));
    this._onFieldInteraction(this._$secondPaySelector);
    // select drop down inside a boolean group, need to use jquery selector instead of cached var
    this._onFieldInteraction($('.js--month-select'));
  };

  this._onOptionSelected = function () {
    // On change boolean group is selected
    this._$secondPaySelector.mogo().hideErrorLabel();
    this._$secondPaySelector.mogo().hideError();

    // If dropdown selected
    if (this._$secondPaySelector.find('select').val()) {
      this._$secondPaySelector.find('select').mogo().hideError();
      this._$secondPaySelector.find('select').mogo().hideErrorLabel();
    }
  };

  this._createSecondDropDown = function () {
    for (var i = parseInt(this._firstPayDay) + 1; i < 30; i++) {
      var isLast = i === 29;
      this._$secondPaySelector.find('select').mogo().addOption(i, i, false, isLast);
    }
    // Pre fill drop down because second drop down is dynamically created above
    var secondDateString = this.presenter.getModelProperty('money._loanApplicationIncome.second_pay_date');
    if (secondDateString) {
      var secondPayDate = moment(secondDateString).format('D');
      var item = 'option[value=\'' + secondPayDate + '\']';
      if (this._$secondPaySelector.find(item).length) {
        this._$secondPayDateDropDown.mogo().val(secondPayDate);
      } else {
        this._$secondPayDateDropDown.mogo().setSelectedIndex(0);
      }
    }
  };

  this._onSubmitIncomeSuccess = function () {
    this._pushPayDateFormSubmitAnalytics('second');
    this._setSubmissionFlag(true);
    // If it's edit mode, go to the next page then create,
    // Note: _loanAppGoToNextStep resets editMode to false;
    if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
      $('#LoanApplicationTray').mogo()._loanAppGoToNextStep();

      $('#Notification').mogo().create({
        type: 'success',
        msg: 'Your loan payment dates have been adjusted based on your new pay frequency. Make sure you review your application carefully before submitting it.'
      });
    } else {
      $('#LoanApplicationTray').mogo()._loanAppGoToNextStep();
    }
  };

  this._onSubmitIncomeFailure = function (data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, {
          productLabel: 'Money'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      this._$nextBtn.mogo().removeDisabledLoadState();

      $('#Notification').mogo().create({
        type: 'custom',
        msg: '<h2><span class="icon--warning"/>Oh no...</h2>' + "We're having some technical issues. Please try again. If the problem persists, try us again in a few minutes.",
        customClass: 'loan-application-notification--warning',
        notificationDescriber: 'error'
      });

      $.each(data.errors, function (index, element) {
        console.warn('key: ' + element.key + ', ' + ('msg: ' + element.msg));
      });
    }
  };

  this.destroy = function () {
    this._super();
    if (this._submissionFlag === false) {
      this._pushAbandonmentData();
    }
  };

  // Analytics
  this._pushPageAnalytics = function (string) {
    var url = window.location.pathname;

    if (string === 'first') {
      url += this.presenter.getModelProperty('money._loanApplicationEdit') === true ? '/firstpayday-edit' : '/firstpayday';
    } else if (string === 'second') {
      url += this.presenter.getModelProperty('money._loanApplicationEdit') === true ? '/secondpayday-edit' : '/secondpayday';
    }

    this.analytics.forcePushEvent('virtual-page-view', {
      Page: [url]
    });
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this._setSubmissionFlag = function (boolean) {
    if (boolean !== null) this._submissionFlag = boolean;
  };

  this._pushPayDateFormSubmitAnalytics = function (string) {
    var formAnalyticsID = '';

    if (string === 'first') {
      if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
        formAnalyticsID = 'Money-Form Submission-Semi Monthly First Pay Day Edit-null-Form';
      } else {
        formAnalyticsID = 'Money-Form Submission-Semi Monthly First Pay Day-null-Form';
      }
    } else if (string === 'second') {
      if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
        formAnalyticsID = 'Money-Form Submission-Semi Monthly Second Pay Day Edit-null-Form';
      } else {
        formAnalyticsID = 'Money-Form Submission-Semi Monthly Second Pay Day-null-Form';
      }
    }

    this.analytics.forcePushEvent('form-submit', {
      FormID: [formAnalyticsID]
    });
  };

  this._setPayDateAttr = function (string) {
    var formAnalyticsID = '';

    if (string === 'first') {
      if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
        formAnalyticsID = ' Money-Semi Monthly First Pay Day Edit-Form attempt-null-SubmitClick';
      } else {
        formAnalyticsID = 'Money-Semi Monthly First Pay Day-Form attempt-null-SubmitClick';
      }
    } else if (string === 'second') {
      if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
        formAnalyticsID = 'Money-Semi Monthly Second Pay Day Edit-Form attempt-null-SubmitClick';
      } else {
        formAnalyticsID = 'Money-Semi Monthly Second Pay Day-Form attempt-null-SubmitClick';
      }
    }

    this._$nextBtn.attr('data-analytics-id', formAnalyticsID);
  };

  this._onFieldInteraction = function (domElement) {
    var elemName = domElement.attr('name');

    if (!elemName) return console.warn('Cannot find name in domElement, please pass through correct domElement');

    var elem = $('[name=\'' + elemName + '\']', this.node);
    var fieldComponent = $(elem).mogo();

    // From UI Schema Validation
    if (fieldComponent instanceof Select) {
      $(fieldComponent.containerDiv).on('enter', setInteractionField.bind(this, elem));
      $(fieldComponent.containerDiv).on('leave', setInteractionField.bind(this, elem));
      $(elem).on('focus', setInteractionField.bind(this, elem));
      $(elem).on('blur', setInteractionField.bind(this, elem));
    } else if (fieldComponent instanceof BooleanGroup) {
      for (var j = 0; j < fieldComponent.groupElements.length; j++) {
        $(fieldComponent.groupElements[j]).on('focus', setInteractionField.bind(this, elem));
        $(fieldComponent.groupElements[j]).on('blur', setInteractionField.bind(this, elem));
      }
    }

    function setInteractionField(elem, event) {
      $(elem)[0].dataset.interacted = true;
    }
  };

  this._findInteractedFields = function () {
    var fields = this._$form[0].elements;

    for (var i = 0; i < fields.length; i++) {
      if (fields[i].dataset.interacted === 'true') {
        this._fieldsInteractedWith.push(fields[i].name);
        fields[i].dataset.interacted = 'false'; // reset fields
      }
      // Boolean Group
      if (fields[i].localName === 'fieldset' && fields[i].parentElement.dataset.interacted === 'true') {
        this._fieldsInteractedWith.push($(fields[i].parentElement).attr('name'));
        fields[i].parentElement.dataset.interacted = 'false'; // reset fields
      }
    }
  };

  this._resetInteractedFields = function () {
    var fields = this._$form[0].elements;

    for (var i = 0; i < fields.length; i++) {
      if (fields[i].dataset.interacted === 'true') {
        fields[i].dataset.interacted = 'false'; // reset fields
      }
      // Boolean Group
      if (fields[i].localName === 'fieldset' && fields[i].parentElement.dataset.interacted === 'true') {
        fields[i].parentElement.dataset.interacted = 'false'; // reset fields
      }
    }

    this._fieldsInteractedWith = [];
  };

  this._pushAbandonmentData = function () {
    this._findInteractedFields();

    if (this._fieldsInteractedWith.length) {
      this.analytics.forcePushEvent('form-abandoned', {
        FormAbandoned: [this._fieldsInteractedWith.join(', ')]
      });
    }
  };

  this._pushFormErrorAnalytics = function (formId) {
    var formErrorId = null;
    if (formId) formErrorId = formId;

    this.analytics.forcePushEvent('form-errors', {
      FormErrors: [formErrorId]
    });
  };
}